import { SVGProps } from "react";

const STIOpencast = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-label="Opencast" role="img" viewBox="0 0 512 512" width="1em" height="1em" {...props}><rect width={512} height={512} rx="15%" fill="#fff" /><path d="m38 256 156-156v72l-84 84 84 84v72z" fill="#24425d" /><path d="M474 256L318 100v72l84 84-84 84v72zm-124 0L194 100v72l84 84-84 84v72z" fill="#4bb07b" /></svg>;

export { STIOpencast };